import { invasionSections } from './invasion';
import { outbreakSections } from './outbreak';
import { blackoutSections } from './blackout';
import { monolithSections } from './monolith';
import type { AlienRuleSection, AlienScenarioId } from './types';

export const alienInvasionSections: AlienRuleSection[] = [
  ...invasionSections,
  ...outbreakSections,
  ...blackoutSections,
  ...monolithSections,
];

export const alienInvasionSectionById = Object.fromEntries(
  alienInvasionSections.map((section) => [section.id, section]),
) as Record<string, AlienRuleSection>;

export function getAlienInvasionSections(
  scenarioId: AlienScenarioId,
): AlienRuleSection[] {
  return alienInvasionSections.filter(
    (section) => section.scenarioId === scenarioId,
  );
}
